module.exports = __webpack_public_path__ + "img/logo-PMup.4b2fc499.jpg";